import Typography from '@mui/material/Typography';
import React, {Fragment} from 'react';

const NotFound = () => (
  <Fragment>
    <Typography>Not found</Typography>
  </Fragment>
);

export default NotFound;
